// Shared header for portfolio sub-pages: back button, overline, M3 headline hierarchy (h1 = Display Small).
(function () {
  const { Box, Typography } = MaterialUI;

  // True while a section is rendered under the hub toolbar: the hub already provides the h1, the "Portfolio"
  // overline and the way back, so the section header drops them and uses an h2.
  const PortfolioEmbedContext = React.createContext(false);

  // titleSx / subtitleSx: type style overrides picked for the page (CaseStudyPage); with them the title also gets more room below it
  function PortfolioPageHeader({ overline: overlineProp, title, subtitle, backLabel = 'Portfolio', onBack, actions, titleSx, subtitleSx }) {
    const { Button, GoogleIcon, LabelPills } = window.Components;
    const embedded = React.useContext(PortfolioEmbedContext);
    const showBack = !(embedded && (embedded === 'workspace' || backLabel === 'Portfolio'));
    const overline = embedded && overlineProp === 'Portfolio' ? undefined : overlineProp;
    return (
      <Box sx={{ mb: titleSx ? 6 : 4 }}>
        {showBack && <Button variant="text" size="small" onClick={onBack} icon={<GoogleIcon name="arrow_back" size={18} />} sx={{ mb: 2, ml: -1 }}>
          {backLabel}
        </Button>}
        {overline && <LabelPills text={overline} sx={{ mb: 1.5 }} />}
        <Typography variant={embedded ? 'h4' : 'h3'} component={embedded ? 'h2' : 'h1'} sx={{ mb: subtitle ? (titleSx ? 2 : 1) : 0, ...(titleSx || {}), ...(titleSx && { fontWeight: 500 }) }}>{title}</Typography>
        {subtitle && <Typography variant="body1" sx={{ color: 'text.secondary', maxWidth: 720, ...(subtitleSx || {}) }}>{subtitle}</Typography>}
        {actions && <Box sx={{ mt: 2, display: 'flex', gap: 1, flexWrap: 'wrap' }}>{actions}</Box>}
      </Box>
    );
  }

  window.Components = window.Components || {};
  window.Components.PortfolioPageHeader = PortfolioPageHeader;
  window.Components.PortfolioEmbedContext = PortfolioEmbedContext;
})();
